// AWS Configuration - Update these values after deploying SAM template
const awsConfig = {
  region: 'us-east-1',
  userPoolId: 'us-east-1_RAZbwnPXd', // From SAM output
  userPoolWebClientId: '6usmhpeba20sdqa6732jm4l4o1', // From SAM output
  apiEndpoint: 'https://1hc1ss2g77.execute-api.us-east-1.amazonaws.com/dev/' // From SAM output
};

export default awsConfig;
